export default {
    games: [],
    gameNames: [],
    archive: [],
    singleGame: {},
    stock: {},
    IGVGames: []
}